import { render } from "./PublicationsConfigPanel.vue.js?vue&type=template&id=b33a14c6!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationsConfigPanel.vue?vue&type=template&id=b33a14c6"
import script from "./PublicationsConfigPanel.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationsConfigPanel.vue?vue&type=script&lang=js"
export * from "./PublicationsConfigPanel.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationsConfigPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/create-dashboard/PublicationsConfigPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b33a14c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b33a14c6', __exports__)) {
    api.reload('b33a14c6', __exports__)
  }
  
  module.hot.accept("./PublicationsConfigPanel.vue.js?vue&type=template&id=b33a14c6!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationsConfigPanel.vue?vue&type=template&id=b33a14c6", () => {
    api.rerender('b33a14c6', render)
  })

}


export default __exports__